export const googleFonts = [
  { id: "playfair", name: "Playfair Display", family: "'Playfair Display', serif", category: "Serif" },
  { id: "montserrat", name: "Montserrat", family: "'Montserrat', sans-serif", category: "Sans-serif" },
  { id: "space", name: "Space Mono", family: "'Space Mono', monospace", category: "Monospace" },
  { id: "cormorant", name: "Cormorant Garamond", family: "'Cormorant Garamond', serif", category: "Serif" },
  { id: "inter", name: "Inter", family: "'Inter', sans-serif", category: "Sans-serif" },
  { id: "roboto", name: "Roboto", family: "'Roboto', sans-serif", category: "Sans-serif" },
  { id: "oswald", name: "Oswald", family: "'Oswald', sans-serif", category: "Sans-serif" },
  { id: "lobster", name: "Lobster", family: "'Lobster', cursive", category: "Display" },
  { id: "bebax", name: "Bebas Neue", family: "'Bebas Neue', sans-serif", category: "Display" },
  { id: "lora", name: "Lora", family: "'Lora', serif", category: "Serif" },
  { id: "cinzel", name: "Cinzel Decorative", family: "'Cinzel Decorative', cursive", category: "Display" },
  { id: "questrial", name: "Questrial", family: "'Questrial', sans-serif", category: "Sans-serif" },
];

export const getGoogleFontImport = (fonts: string[]) => {
  const families = fonts.map(f => {
    if (f === "playfair") return "Playfair+Display:ital,wght@0,400..900;1,400..900";
    if (f === "montserrat") return "Montserrat:wght@100..900";
    if (f === "space") return "Space+Mono:ital,wght@0,400;0,700;1,400;1,700";
    if (f === "cormorant") return "Cormorant+Garamond:ital,wght@0,300..700;1,300..700";
    if (f === "inter") return "Inter:wght@100..900";
    if (f === "roboto") return "Roboto:wght@100..900";
    if (f === "oswald") return "Oswald:wght@200..700";
    if (f === "lobster") return "Lobster";
    if (f === "bebax") return "Bebas+Neue";
    if (f === "lora") return "Lora:ital,wght@0,400..700;1,400..700";
    if (f === "cinzel") return "Cinzel+Decorative:wght@400;700;900";
    if (f === "questrial") return "Questrial";
    return null;
  }).filter(Boolean);

  if (families.length === 0) return "";
  return `https://fonts.googleapis.com/css2?family=${families.join("&family=")}&display=swap`;
};

/*
.font-cinzel { font-family: 'Cinzel Decorative', cursive; }
.font-questrial { font-family: 'Questrial', sans-serif; }
*/
